import {Component, ComponentFactoryResolver, OnInit, ViewChild} from '@angular/core';
import {PitDashboardService} from "../../../services/pit-dashboard.service";
import {PitActivityVersion} from "../../../../pit-activities/domain/pit-activity-version";
import {DxGridComponent} from "../../../../dx-grid/ui/components/dx-grid-component";
import {DxGridOptions} from "../../../../dx-grid/domain/ui-options/dx-grid-options";
import {PitFile} from "../../../../pit-shared/domain/pit-file";
import {DxModalResultType} from "../../../../dx-modals/domain/dx-modal-result-type";
import {Observable} from "rxjs";
import {PitFileUploadModalComponent} from "../file-upload-modal/pit-file-upload-modal.component";
import {DxModalService} from "../../../../dx-modals/services/dx-modal.service";
import {BdpkFileService} from "../../../../bdpk-common/services/bdpk-file.service";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";

@Component({
  selector: 'pit-dashboard-files',
  templateUrl: './pit-dashboard-files.component.html',
  styleUrls: ['./pit-dashboard-files.component.css'],
  providers: [
    PitDashboardService
  ]
})
export class PitDashboardFilesComponent implements OnInit {

  /** признак загрузки. По этому признаку влкючается индикатор */
  public isLoading: boolean = false;
  /** сообщение, которое отображается при загрузке/сохранении */
  public loadingMessage: string = 'Загрузка';


  public activityVersion: PitActivityVersion = new PitActivityVersion();

  constructor(private _dashboardService: PitDashboardService,
              private _configService: BdpkConfigService,
              private _resolver: ComponentFactoryResolver,
              private _modalsService: DxModalService,
              private _fileService: BdpkFileService) { }

  /***************** Грид с файлами *******************/

  @ViewChild('filesGrid', {static: false})
  public filesGrid: DxGridComponent;
  public filesGridOptions: DxGridOptions;
  public filesSelectedRow: PitFile;

  /** Показывает индикацию загрузки. */
  protected _showLoader(message?: string): void {
    if (message) this.loadingMessage = message;
    this.isLoading = true;
  }

  /** Скрывает индикацию загрузки. */
  protected _hideLoader(): void {
    this.isLoading = false;
  }

  onFileDelete(): void {
    const index = this.activityVersion.files.findIndex(item => item.fileId === this.filesSelectedRow.fileId);
    this.activityVersion.files.splice(index, 1);
    this.activityVersion.files = [...this.activityVersion.files];
    if (this.activityVersion.files.length === 0) {
      this.filesGrid.state.clearSelected();
    }
  }

  onFileDownload(): void {
    this._fileService.downloadFile(this.filesSelectedRow.fileId);
  }

  onFilesRowSelect(value): void {
    this.filesSelectedRow = value.data[0];
  }

  onFilesRowDeselect(value): void {
    this.filesSelectedRow = null;
  }

  onFileLoad(): void {
    this._showFileLoadForm().subscribe(event => {

      if (DxModalResultType.SAVE !== event.type) {
        return;
      }
      const result = event.data as Map<string, any>;
      if (result) {
        this._fileService.uploadFile(result.get('ctrlFile'), result.get('ctrlFile').name).subscribe(
          file => {
            // добавляем строку к таблице прикрепленных файлов
            let row = PitFile.fromLoadedFile(file, result.get('ctrlDocumentType'), null)
              .setComment(result.get('ctrlNote'));
            //  .setFileEntityId(null);
            this.activityVersion.files = [...this.activityVersion.files, row];
          });
      }
    });
  }

  onGridReady(): void {
    this.filesGrid.resize();
  }

  onSave(): void {
    this._showLoader('Сохранение');
    let activityVersionForSend:PitActivityVersion = Object.assign(new PitActivityVersion(), this.activityVersion);
    activityVersionForSend.financingAmountBySource.forEach(item => { item.financingItem.budgetLevelId = undefined });
    this._dashboardService.updateActivityVersion(activityVersionForSend).subscribe(response => {
      this._hideLoader();
      const message: string = 'Данные успешно сохранены';
      this._modalsService.showInfo(message);
    }, error => {
      this._hideLoader();
    });
  }


  private _showFileLoadForm(): Observable<any> {
    const factory = this._resolver.resolveComponentFactory(PitFileUploadModalComponent);
    const options = this._modalsService.buildEditModalOptions('tiny', 'Прикрепить');

    return this._modalsService.showEditByFactory(factory, null, 'Прикрепить файл', options)
  }



  ngOnInit() {
    this._showLoader();
    // this.filesGridOptions = this._configService.pitActivitiesCardGridOptions.get('PIT_DASHBOARD_FILES');
    this._dashboardService.fetchActivityLastVersion(5162).subscribe(result => {
      this.activityVersion = result;
      this._hideLoader();
    });

  }

}
